import { getGlJournalEntries } from "@/services/gl.service";
import { useQuery } from "@tanstack/react-query";

export const useGlJournalEntries = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  return useQuery({
    queryKey: [
      "gl-journal-entries",
      params.page,
      params.size,
      params.search,
      params.fromDate,
      params.toDate,
      params.eventType,
    ],
    queryFn: () => getGlJournalEntries(params),
    enabled,
    ...options,
  });
};
